/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { Spinner } from 'sarsaparilla';

import { type NavigationRoute } from './navigationRoute';

function ExternalRedirect({ url }: { url: string }) {
    React.useEffect(() => {
        window.location.replace(url);
    }, [url]);

    return <Spinner isFullscreen />;
}

export const externalRedirectRoutes: NavigationRoute[] = [
    {
        path: '/disclaimers',
        element: (
            <ExternalRedirect
                url={`${process.env.SN_KB_EXT_URL}/en/terms-of-service?id=kb_article&sysparm_article=KB0012294`}
            />
        ),
    },
    {
        path: '/foia',
        element: (
            <ExternalRedirect
                url={`${process.env.SN_KB_EXT_URL}/en/freedom-of-information-act?id=kb_article&sysparm_article=KB0011973`}
            />
        ),
    },
];

// cSpell:ignore sysparm
